import { z } from 'zod';

// ---------------------------------------------------------------------------
// ClickHouse readiness probe
// ---------------------------------------------------------------------------

/**
 * Polled by the frontend cold-start banner while it believes CH is cold.
 * `ready: true` means a fresh `SELECT 1` succeeded (or was cached via KV for
 * 60s); `ready: false` means the probe aborted or errored. Once the banner
 * sees `ready: true` it flips the global cold flag warm, and data consumers
 * refetch by subscribing to that flag (`useClickHouseRefetch`).
 */
export const clickhouseReadyResponse = z.object({
  ready: z.boolean(),
});

export type ClickHouseReadyResponse = z.infer<typeof clickhouseReadyResponse>;
